<template>
  <span>Success generating report!</span>
</template>

<script>
export default {
  name: "success-generate-report"
};
</script>
